import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './HomeActionGrid.module.css';

interface Tile {
  key: 'ask' | 'check' | 'lucky' | 'when';
  icon: string;
  route: string;
}

const TILES: Tile[] = [
  { key: 'ask', icon: '🔮', route: '/ask' },
  { key: 'check', icon: '⚖️', route: '/check' },
  { key: 'lucky', icon: '⭐', route: '/lucky' },
  { key: 'when', icon: '⏳', route: '/when' },
];

export function HomeActionGrid(): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation(['home']);
  return (
    <div className={styles.grid} data-testid="home-action-grid">
      {TILES.map((tile) => (
        <button
          key={tile.key}
          type="button"
          className={styles.tile}
          onClick={() => navigate(tile.route)}
          data-testid={`home-action-${tile.key}`}
        >
          <span className={styles.icon}>{tile.icon}</span>
          <span className={styles.label}>{t(`actions.${tile.key}`)}</span>
        </button>
      ))}
    </div>
  );
}
